<template>
  <div>{{ zueri9Client }}</div>
</template>
<script>
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  name: 'Zueri9Clients',
  mixins: [wsMixin],
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
  },
  computed: {
    zueri9Client() {
      return this.mx_zueri9Client(this.absence);
    },
  },
};
</script>